var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"side-bar-overlay"},[_c('div',{staticClass:"side-bar p-3",attrs:{"click-outside":"$emit('close')"}})])
}]

export { render, staticRenderFns }